
import React from 'react';
import './policies.css';

function PaymentMethod() {
  return (
    <div className="policy-page">
      <div className="policy-container">

        <h1>Methods of Payment, Accepted Card Types & Currency</h1>

        <p className="last-updated">
          Last Updated: June 2026
        </p>

        <div className="policy-welcome-box">
          <p>
            At <strong>Mr White</strong>, we provide secure and convenient
            payment options to ensure a smooth checkout experience for all
            customers.
          </p>
        </div>

        <div className="policy-section">
          <h2>Accepted Payment Methods</h2>

          <p>
            We accept payments through approved online payment methods
            available at checkout.
          </p>

          <p>
            Accepted payment methods and card logos (such as
            <strong> Visa</strong>,
            <strong> Mastercard</strong>, and other supported cards)
            will be clearly displayed on the Home Page and Payment Checkout
            Page for customer convenience.
          </p>
        </div>

        <div className="policy-section">
          <h2>Accepted Card Types</h2>

          <ul className="policy-list">
            <li>Visa</li>
            <li>Mastercard</li>
            <li>Other supported payment cards displayed at checkout</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>Transaction Currency</h2>

          <p>
            All transactions and charges on this website are processed in
            <strong> AED (United Arab Emirates Dirham)</strong>,
            unless otherwise specified.
          </p>
        </div>

        <div className="policy-section">
          <h2>Customer Responsibility</h2>

          <p>
            Customers are advised to ensure sufficient funds are available
            and verify all payment information before confirming any
            transaction.
          </p>

          <p>
            Mr White is not responsible for payment failures resulting from
            incorrect card information, insufficient funds, or restrictions
            imposed by the customer's bank or payment provider.
          </p>
        </div>

        <div className="policy-section">
          <h2>Contact Us</h2>

          <p>
            If you have any questions regarding payment methods, accepted
            cards, or transaction currency, please contact us:
          </p>

          <p>
            <strong>Email:</strong>{' '}
            <a href="mailto:customercare@mrwhiteuae.com">
              customercare@mrwhiteuae.com
            </a>
          </p>

          <p>
            <strong>Phone:</strong>{' '}
            <a href="tel:+971585779343">
              +971 58 577 9343
            </a>
          </p>
        </div>

      </div>
    </div>
  );
}

export default PaymentMethod;
